<template>
  <div class="topup-page">
    <!-- 顶部背景装饰 -->
    <div class="page-header">
    </div>

    <!-- 主要内容区域 -->
    <div class="content-container">
      <!-- 左侧：充值选项 -->
      <div class="main-section">
        <!-- 我的账户信息 -->
        <div class="account-card">
          <div class="account-info">
            <div style="display: flex; " v-if="$store.state.dlMark!==null">
                <img style="width: 70px; height: 70px; border-radius: 50%;background-color: black;" 
                :src="$store.state.dlMark!==null?$store.state.dlMark.touxiang:'#'" alt="">
                 <div class="balance-info" >
                    <span class="balance-label">{{ $store.state.dlMark!==null?$store.state.dlMark.nicheng:'' }}</span>
                    <span class="balance-value">{{ $store.state.dlMark!==null?$store.state.dlMark.money:'' }} 硬币</span>
                </div>
            </div>
           
            <div class="first-time-tip" v-if="isFirstRecharge">
              <span class="tip-icon">🎁</span>
              <span class="tip-text">首次充值享双倍返利！</span>
            </div>
          </div>
        </div>

        <!-- 充值说明 -->
        <div class="info-card">
          <h3 class="card-title">💡 充值说明</h3>
          <div class="info-content">
            <div class="info-item">
              <span class="item-icon">🎵</span>
              <div class="item-text">
                <strong>音乐素材：</strong>每个素材需要 1-10 硬币，高品质素材需要更多硬币
              </div>
            </div>
            <div class="info-item">
              <span class="item-icon">🎨</span>
              <div class="item-text">
                <strong>漫画阅读：</strong>付费章节需要 300 硬币解锁，解锁后可永久阅读
              </div>
            </div>
            <div class="info-item">
              <span class="item-icon">💰</span>
              <div class="item-text">
                <strong>充值比例：</strong>1 元 = 10 硬币（首次充值额外赠送等量硬币）
              </div>
            </div>
          </div>
        </div>

        <!-- 充值金额选择 -->
        <div class="recharge-card">
          <h3 class="card-title">选择充值金额</h3>
          
          <!-- 固定金额选项 -->
          <div class="amount-options">
            <div
              v-for="option in rechargeOptions"
              :key="option.amount"
              :class="['amount-option', { active: selectedAmount === option.amount }]"
              @click="selectAmount(option)"
            >
              <div class="option-amount">¥{{ option.amount }}</div>
              <div class="option-coins">
                <span class="coins-value">{{ option.coins }}</span>
                <span class="coins-label">硬币</span>
              </div>
              <div v-if="isFirstRecharge && option.bonus" class="option-bonus">
                +{{ option.bonus }} 赠送
              </div>
            </div>
          </div>

          <!-- 自定义金额 -->
          <div class="custom-amount">
            <label class="custom-label">自定义金额</label>
            <div class="custom-input-wrapper">
              <span class="input-prefix">¥</span>
              <input
                type="number"
                v-model="customAmount"
                placeholder="请输入充值金额"
                min="1"
                class="custom-input"
                @input="onCustomAmountChange"
              />
            </div>
            <div v-if="customAmount > 0" class="custom-result">
              <span class="result-text">将获得</span>
              <span class="result-coins">{{ calculatedCoins }}</span>
              <span class="result-unit">硬币</span>
              <span v-if="isFirstRecharge && customAmount >= 1" class="result-bonus">
                + {{ calculatedBonus }} 首次充值赠送
              </span>
            </div>
          </div>
        </div>

        <!-- 支付方式 -->
        <div class="payment-card">
          <h3 class="card-title">选择支付方式</h3>
          <div class="payment-methods">
            <div
              v-for="method in paymentMethods"
              :key="method.id"
              :class="['payment-method', { active: selectedPayment === method.id }]"
              @click="selectPayment(method.id)"
            >
                <img class="method-icon" style="width: 35px; height: 35px;" src="../../assets/image/weixin.png" alt="">
              <span class="method-name">{{ method.name }}</span>
            </div>
          </div>
        </div>

        <!-- 充值按钮 -->
        <button
          class="recharge-btn"
          :class="{ disabled: !canRecharge }"
          :disabled="!canRecharge"
          @click="handleRecharge"
        >
          <span v-if="!recharging">{{selectedAmount}}元</span>
          <span v-else class="loading-text">
            <span class="spinner"></span>
            处理中...
          </span>
        </button>

        <!-- 错误提示 -->
        <!-- <div v-if="errorMessage" class="error-message">
          <span class="error-icon">⚠️</span>
          <span>{{ errorMessage }}</span>
          <button class="error-close" @click="errorMessage = ''">×</button>
        </div> -->
      </div>

      <!-- 右侧：福利优惠 -->
      <div class="sidebar-section">
        <!-- 首次充值优惠 -->
        <div class="benefit-card highlight">
          <div class="benefit-header">
            <span class="benefit-icon">🎁</span>
            <h3 class="benefit-title">首次充值优惠</h3>
          </div>
          <div class="benefit-content">
            <p class="benefit-desc">
              首次充值享受 <strong>双倍返利</strong>！充值 1 元即可获得 20 硬币（10 硬币 + 10 赠送）
            </p>
            <div class="benefit-examples">
              <div class="example-item">
                <span>充值 ¥1</span>
                <span>→ 获得 20 硬币</span>
              </div>
              <div class="example-item">
                <span>充值 ¥10</span>
                <span>→ 获得 200 硬币</span>
              </div>
              <div class="example-item">
                <span>充值 ¥50</span>
                <span>→ 获得 1000 硬币</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 充值优惠活动 -->
        <div class="benefit-card">
          <div class="benefit-header">
            <span class="benefit-icon">🎉</span>
            <h3 class="benefit-title">限时优惠</h3>
          </div>
          <div class="benefit-content">
            <div class="activity-item">
              <span class="activity-badge">热销</span>
              <p>充值满 100 元额外赠送 50 硬币</p>
            </div>
            <div class="activity-item">
              <span class="activity-badge">推荐</span>
              <p>每周充值满 50 元即可参与抽奖</p>
            </div>
          </div>
        </div>

        <!-- 快速计算 -->
        <!-- <div class="calculator-card">
          <h3 class="card-title">💡 快速计算</h3>
          <div class="calculator-content">
            <div class="calc-item">
              <span class="calc-label">解锁 1 话漫画</span>
              <span class="calc-value">需要 ¥19</span>
            </div>
            <div class="calc-item">
              <span class="calc-label">解锁 1 个音乐素材</span>
              <span class="calc-value">需要 ¥1-3</span>
            </div>
            <div class="calc-item">
              <span class="calc-label">解锁 10 个音乐素材</span>
              <span class="calc-value">需要 ¥10-30</span>
            </div>
          </div>
        </div> -->

        <!-- 帮助与反馈 -->
        <div class="help-card">
          <h3 class="card-title">❓ 需要帮助？</h3>
          <div class="help-content">
            <button class="help-btn" @click="showFeedback = true">
              <span>💬</span>
              <span>问题反馈</span>
            </button>
            <button class="help-btn" @click="showFAQ = true">
              <span>📖</span>
              <span>常见问题</span>
            </button>
            <button class="help-btn" @click="contactService">
              <span>🆘</span>
              <span>联系客服</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 反馈弹窗 -->
    <div v-if="showFeedback" class="modal-overlay" @click="showFeedback = false">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>问题反馈</h3>
          <button class="modal-close" @click="showFeedback = false">×</button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>问题类型</label>
            <select v-model="feedback.type" class="form-input">
              <option value="recharge_failed">充值失败</option>
              <option value="coin_not_received">未收到硬币</option>
              <option value="payment_error">支付异常</option>
              <option value="other">其他问题</option>
            </select>
          </div>
          <div class="form-group">
            <label>问题描述</label>
            <textarea
              v-model="feedback.content"
              class="form-input"
              rows="5"
              placeholder="请详细描述您遇到的问题..."
            ></textarea>
          </div>
          <div class="form-group">
            <label>联系方式（选填）</label>
            <input
              v-model="feedback.contact"
              type="text"
              class="form-input"
              placeholder="邮箱或手机号"
            />
          </div>
          <button class="submit-btn" @click="submitFeedback">提交反馈</button>
        </div>
      </div>
    </div>

    <!-- FAQ弹窗 -->
    <div v-if="showFAQ" class="modal-overlay" @click="showFAQ = false">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>常见问题</h3>
          <button class="modal-close" @click="showFAQ = false">×</button>
        </div>
        <div class="modal-body">
          <div class="faq-item">
            <h4>Q: 充值后未收到硬币怎么办？</h4>
            <p>A: 充值成功后硬币通常会在 1-3 分钟内到账，如未到账请联系客服处理。</p>
          </div>
          <div class="faq-item">
            <h4>Q: 首次充值优惠如何领取？</h4>
            <p>A: 首次充值时系统会自动赠送等量硬币，无需额外操作。</p>
          </div>
          <div class="faq-item">
            <h4>Q: 充值失败怎么办？</h4>
            <p>A: 请检查网络连接和账户余额，如仍失败请通过问题反馈联系我们。</p>
          </div>
          <div class="faq-item">
            <h4>Q: 硬币会过期吗？</h4>
            <p>A: 硬币永久有效，不会过期，可随时使用。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Chongzhi',
  data() {
    return {
      userBalance: 0, // 当前余额
      isFirstRecharge: true, // 是否首次充值
      selectedAmount:0, // 选中的固定金额
      customAmount: '', // 自定义金额
      selectedPayment: 'alipay', // 选中的支付方式
      recharging: false, // 是否正在充值
      errorMessage: '', // 错误信息
      showFeedback: false, // 显示反馈弹窗
      showFAQ: false, // 显示FAQ弹窗
      feedback: {
        type: 'recharge_failed',
        content: '',
        contact: ''
      },
      // 固定充值选项
      rechargeOptions: [
        { amount: 10, coins: 100, bonus: 100 },
        { amount: 30, coins: 300, bonus:300 },
        { amount: 68, coins: 680, bonus: 680 },
        { amount: 198, coins: 1980, bonus: 1980 },
        { amount: 328, coins: 3280, bonus: 3280 },
        { amount: 648, coins: 6480, bonus: 6480 }
      ],
      // 支付方式
      paymentMethods: [
        { id: 'wechat', name: '微信支付', icon: '💚' }
      ]
    }
  },
  computed: {
    // 计算自定义金额对应的硬币
    calculatedCoins() {
      const amount = parseFloat(this.customAmount) || 0
      return Math.floor(amount * 10)
    },
    // 计算首次充值赠送
    calculatedBonus() {
      if (!this.isFirstRecharge) return 0
      const amount = parseFloat(this.customAmount) || 0
      return Math.floor(amount * 10)
    },
    // 是否可以充值
    canRecharge() {
      return (this.selectedAmount || (this.customAmount && parseFloat(this.customAmount) >= 1)) && !this.recharging
    },
    // 当前充值金额
    currentRechargeAmount() {
      if (this.selectedAmount) {
        const option = this.rechargeOptions.find(o => o.amount === this.selectedAmount)
        return option ? option.amount : 0
      }
      return parseFloat(this.customAmount) || 0
    },
    // 当前充值获得的硬币
    currentRechargeCoins() {
      if (this.selectedAmount) {
        const option = this.rechargeOptions.find(o => o.amount === this.selectedAmount)
        if (option) {
          return this.isFirstRecharge ? option.coins + option.bonus : option.coins
        }
      }
      if (this.customAmount && parseFloat(this.customAmount) >= 1) {
        return this.isFirstRecharge 
          ? this.calculatedCoins + this.calculatedBonus 
          : this.calculatedCoins
      }
      return 0
    }
  },
  mounted() {
    // 获取用户余额等信息
    this.fetchUserInfo()
  },
  methods: {
    // 获取用户信息
    fetchUserInfo() {
      // 这里应该从API获取用户信息
      // 示例：模拟获取
      // this.userBalance = userInfo.balance
      // this.isFirstRecharge = userInfo.isFirstRecharge
    },
    // 选择固定金额
    selectAmount(option) {
    console.log('选择金额:', option.amount)
      this.selectedAmount = option.amount
      this.customAmount = ''
    },
    // 自定义金额变化
    onCustomAmountChange() {
      this.selectedAmount = 0
      const amount = parseFloat(this.customAmount)
      if (amount && amount < 1) {
        this.customAmount = ''
        this.errorMessage = '最低充值金额为 1 元'
        setTimeout(() => { 
          this.errorMessage = ''
        }, 3000)
      }else{
        console.log('自定义金额:', amount)
        this.selectedAmount = amount>=1?amount:0;
      }
    },
    // 选择支付方式
    selectPayment(methodId) {
      this.selectedPayment = methodId
    },
    // 处理充值
    handleRecharge() {
      if(this.$store.state.dlMark !== null){
        if(localStorage.getItem('isWcnrEnabled')=='false'){
          window.open('index/index/wxpay.html?price='+this.selectedAmount,'_blank')
        }else{
          this.$message.warning('青少年禁止充值！');
        }
      }else{
        this.$message.warning('请登录后充值！')
      }
    },
    // 提交反馈
    submitFeedback() {
      if (!this.feedback.content.trim()) {
        alert('请填写问题描述')
        return
      }
      
      // 这里应该调用API提交反馈
      console.log('提交反馈:', this.feedback)
      alert('反馈已提交，我们会尽快处理！')
      
      // 重置表单
      this.feedback = {
        type: 'recharge_failed',
        content: '',
        contact: ''
      }
      this.showFeedback = false
    },
    // 联系客服
    contactService() {
      alert('客服微信：zqwzbs@126.com\n联系方式：010-64098960\n工作时间：9:00-22:00')
    }
  }
}
</script>

<style lang="scss" scoped>
.topup-page {
  min-height: 100vh;
  background: #f5f5f5;
  padding-bottom: 40px;
}

/* 页面头部 */
.page-header {
background-color: #1a1a1a;
width: 100%;
height: 65px;
  text-align: center;
  color: #fff;
  margin-bottom: 30px;
  position: fixed;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
}

.page-title {
  font-size: 36px;
  font-weight: 700;
  margin: 0 0 12px;
}

.page-subtitle {
  font-size: 16px;
  opacity: 0.9;
  margin: 0;
}

/* 内容容器 */
.content-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  padding-top: 90px;
  display: grid;
  grid-template-columns: 1fr 360px;
  gap: 24px;
}

/* 主区域卡片 */
.main-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.account-card,
.info-card,
.recharge-card,
.payment-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #f0f0f0;
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 20px;
}

/* 账户信息 */
.account-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.balance-info {
  display: flex;
  flex-direction: column;
  margin-left: 20px;
}

.balance-label {
  font-size: 22px;
  color: #141414;
}

.balance-value {
  font-size: 28px;
  font-weight: 700;
  color: #667eea;
}

.first-time-tip {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: linear-gradient(135deg, #ff6b6b, #ee5a6f);
  border-radius: 20px;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
}

.tip-icon {
  font-size: 18px;
}

/* 信息卡片 */
.info-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.info-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.item-icon {
  font-size: 24px;
  flex-shrink: 0;
}

.item-text {
  flex: 1;
  font-size: 14px;
  color: #666;
  line-height: 1.6;

  strong {
    color: #1a1a1a;
    font-weight: 600;
  }
}

/* 充值选项 */
.amount-options {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 24px;
}

.amount-option {
  position: relative;
  padding: 20px;
  background: #fafafa;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: #667eea;
    background: #f5f7ff;
    transform: translateY(-2px);
  }

  &.active {
    border-color: #667eea;
    background: linear-gradient(135deg, #667eea15, #764ba215);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
  }
}

.option-amount {
  font-size: 24px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 8px;
}

.option-coins {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.coins-value {
  font-size: 20px;
  font-weight: 600;
  color: #667eea;
}

.coins-label {
  font-size: 12px;
  color: #999;
}

.option-bonus {
  position: absolute;
  top: 8px;
  right: 8px;
  padding: 4px 8px;
  background: #ff6b6b;
  color: #fff;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
}

/* 自定义金额 */
.custom-amount {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #f0f0f0;
}

.custom-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 12px;
}

.custom-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-prefix {
  position: absolute;
  left: 16px;
  font-size: 16px;
  font-weight: 600;
  color: #666;
  z-index: 1;
}

.custom-input {
  width: 100%;
  padding: 12px 16px 12px 36px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 16px;
  color: #1a1a1a;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }

  &::placeholder {
    color: #aaa;
  }
}

.custom-result {
  margin-top: 12px;
  padding: 12px;
  background: #f5f7ff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.result-text {
  font-size: 14px;
  color: #666;
}

.result-coins {
  font-size: 20px;
  font-weight: 700;
  color: #667eea;
}

.result-unit {
  font-size: 14px;
  color: #666;
}

.result-bonus {
  font-size: 13px;
  color: #ff6b6b;
  font-weight: 600;
}

/* 支付方式 */
.payment-methods {
  display: flex;
  gap: 12px;
}

.payment-method {
  flex: 1;
  padding: 16px;
  background: #fafafa;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: #667eea;
    background: #f5f7ff;
  }

  &.active {
    border-color: #667eea;
    background: linear-gradient(135deg, #667eea15, #764ba215);
  }
}

.method-icon {
  font-size: 32px;
}

.method-name {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

/* 充值按钮 */
.recharge-btn {
  width: 100%;
  padding: 16px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: #fff;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 20px;

  &:hover:not(.disabled) {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.4);
  }

  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .loading-text {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }

  .spinner {
    width: 16px;
    height: 16px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top-color: #fff;
    border-radius: 50%;
    animation: spin 0.6s linear infinite;
  }
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* 错误提示 */
.error-message {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 8px;
  color: #856404;
  font-size: 14px;
  margin-top: 12px;
}

.error-icon {
  font-size: 18px;
}

.error-close {
  margin-left: auto;
  background: none;
  border: none;
  font-size: 20px;
  color: #856404;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 侧边栏 */
.sidebar-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.benefit-card,
.calculator-card,
.help-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #f0f0f0;
}

.benefit-card.highlight {
  background: linear-gradient(135deg, #fff5f5, #fff9f0);
  border-color: #ff6b6b;
}

.benefit-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.benefit-icon {
  font-size: 24px;
}

.benefit-title {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
}

.benefit-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin: 0 0 16px;
}

.benefit-examples {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.example-item {
  display: flex;
  justify-content: space-between;
  padding: 8px 12px;
  background: #ffffff;
  border-radius: 6px;
  font-size: 13px;
  color: #333;

  span:first-child {
    font-weight: 600;
    color: #667eea;
  }
}

.activity-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px;
  background: #fafafa;
  border-radius: 8px;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }
}

.activity-badge {
  padding: 4px 8px;
  background: #ff6b6b;
  color: #fff;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  flex-shrink: 0;
}

.activity-item p {
  margin: 0;
  font-size: 13px;
  color: #666;
  line-height: 1.5;
}

/* 计算器 */
.calculator-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.calc-item {
  display: flex;
  justify-content: space-between;
  padding: 10px 12px;
  background: #fafafa;
  border-radius: 6px;
}

.calc-label {
  font-size: 13px;
  color: #666;
}

.calc-value {
  font-size: 13px;
  font-weight: 600;
  color: #667eea;
}

/* 帮助卡片 */
.help-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.help-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  background: #fafafa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #f5f7ff;
    border-color: #667eea;
    color: #667eea;
  }

  span:first-child {
    font-size: 18px;
  }
}

/* 弹窗 */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: #ffffff;
  border-radius: 12px;
  max-width: 500px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #f0f0f0;

  h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #1a1a1a;
  }
}

.modal-close {
  background: none;
  border: none;
  font-size: 24px;
  color: #999;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;

  &:hover {
    background: #f5f5f5;
    color: #333;
  }
}

.modal-body {
  padding: 20px;
}

.form-group {
  margin-bottom: 20px;

  label {
    display: block;
    font-size: 14px;
    font-weight: 500;
    color: #333;
    margin-bottom: 8px;
  }
}

.form-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  color: #1a1a1a;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }

  &::placeholder {
    color: #aaa;
  }
}

.submit-btn {
  width: 100%;
  padding: 12px;
  background: #667eea;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #5568d3;
  }
}

.faq-item {
  padding: 16px 0;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }

  h4 {
    margin: 0 0 8px;
    font-size: 15px;
    font-weight: 600;
    color: #1a1a1a;
  }

  p {
    margin: 0;
    font-size: 14px;
    color: #666;
    line-height: 1.6;
  }
}

/* 响应式设计 */
@media (max-width: 968px) {
  .content-container {
    grid-template-columns: 1fr;
  }

  .amount-options {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .page-title {
    font-size: 28px;
  }

  .amount-options {
    grid-template-columns: 1fr;
  }

  .payment-methods {
    flex-direction: column;
  }

  .content-container {
    padding: 0 12px;
  }

  .account-card,
  .info-card,
  .recharge-card,
  .payment-card {
    padding: 20px;
  }
}
</style>

